export default __webpack_public_path__ + "static/media/Sailor.97b8072c.png";